import { CardItem } from '../types/common';
// import Wildberries from '../assets/images/wildberries.png';
// import Yandex from '../assets/images/yandex.png';
// import Avito from '../assets/images/avito.png';
// import Ozon from '../assets/images/ozon.png';
// import { ReactComponent as Kazanexpress } from '../assets/images/kazanexpress.svg';
import CopyMonkeyAIIcon from '../assets/images/CopyMonkey_Logo_Monkey.png'
import Instagram from '../assets/images/instagram.png';
import { ReactComponent as Rutube } from '../assets/images/rutube.svg';
import ProductDescription from '../assets/images/product-description.png';
import YouTubeIcon from '@mui/icons-material/YouTube';

export const CARDS: CardItem[] = [
  {
    id: 10,
    url: 'chat',
    mode: 'chat',
    groupId: 3,
    name: 'Универсальный AI-помощник',
    description: 'Решайте любые ваши задачи с помощью CopyMonkey AI в формате диалога',
    icon: <img src={CopyMonkeyAIIcon} width={'40px'} alt="AI Chat" />,
  },
  {
    id: 1,
    url: 'blog',
    mode: 'blog',
    groupId: 3,
    name: 'Статьи и SEO-тексты',
    description: 'Создайте SEO-текст для вашего блога и веб-сайта',
    icon: <div>🗣️</div>,
  },
  {
    id: 2,
    url: 'instagram',
    mode: 'instagram',
    groupId: 2,
    name: 'Пост для блога и социальных сетей',
    description: 'Напишите креативные тексты для вашего блога',
    icon: <img src={Instagram} width={'40px'} alt="Instagram" />,
  },
  {
    id: 3,
    url: 'youtube',
    mode: 'rutube_description',
    groupId: 2,
    name: 'Описание видео YouTube',
    description: 'Напишите описание, которое будет хорошо индексироваться на YouTube',
    icon: <YouTubeIcon sx={{ color: '#f20f19', fontSize: '56px' }} />,
    // icon: <Rutube width={'100px'} />,
  },
  {
    id: 4,
    url: 'youtube-review',
    mode: 'rutube_review',
    groupId: 2,
    name: 'Комментарий для YouTube видео',
    description: 'Напишите комментарий к видео на YouTube',
    icon: <YouTubeIcon sx={{ color: '#f20f19', fontSize: '56px' }} />,
    // icon: <Rutube width={'100px'} />,
  },
  {
    id: 5,
    url: 'product',
    mode: 'product_description',
    groupId: 4,
    name: 'Описание товара',
    description: 'Генерация описаний товаров для интернет-магазина и маркетплейсов',
    icon: <img src={ProductDescription} width={'50px'} alt="Описание товара" />,
  },
  {
    id: 6,
    url: 'category',
    mode: 'product_category',
    groupId: 4,
    name: 'Категория товара',
    description: 'Уникальное описание для верхнеуровневой категории товара',
    icon: <div>🪄</div>,
  },
  {
    id: 7,
    url: 'review',
    mode: 'review',
    groupId: 4,
    name: 'Отзыв на товар',
    description: 'Напишите уникальный отзыв на товар',
    icon: <div>📜</div>,
  },
  {
    id: 8,
    url: 'website',
    mode: 'website',
    groupId: 5,
    name: 'Тексты для веб-сайта и лендингов',
    description: 'Наполните сайт убедительными и креативными текстами о вашем бизнесе',
    icon: <div>💭</div>,
  },
  {
    id: 9,
    url: 'email',
    mode: 'mail',
    groupId: 6,
    name: 'Текст письма для рассылки',
    description: 'Создавайте тексты маркетинговых рассылок и холодных писем',
    icon: <div>📨</div>,
  },

  // {
  //   id: 'wildberries',
  //   groupId: 4,
  //   name: 'Wildberries',
  //   description: 'Описания и буллит-поинты для Wildberries',
  //   icon: <img src={Wildberries} width={'120px'} alt="Wildberries" />,
  // },
  // {
  //   id: 'ozon',
  //   groupId: 4,
  //   name: 'Ozon',
  //   description: 'Описание для товара на Ozon',
  //   icon: <img src={Ozon} width={'100px'} alt="Ozon" />,
  // },

  // {
  //   id: 'yandex-market',
  //   groupId: 4,
  //   name: 'Яндекс.Маркет',
  //   description: 'Описания для товара на Яндекс.Маркете',
  //   icon: <img src={Yandex} alt="Яндекс.Маркет" width={'50px'} />,
  // },

  // {
  //   id: 'kazan-express',
  //   groupId: 4,
  //   name: 'Kazan.Express',
  //   description: 'Описания для товара на Kazan.Express',
  //   icon: <Kazanexpress width={'50px'} />,
  // },

  // {
  //   id: 'avito',
  //   groupId: 4,
  //   name: 'Avito',
  //   description: 'Описание для товара на Avito',
  //   icon: <img src={Avito} width={'120px'} alt="Авито" />,
  // },
];

export const TEMPLATE_TABS = [
  {
    id: 1,
    name: 'Все шаблоны',
  },
  {
    id: 2,
    name: 'Социальные сети',
  },
  {
    id: 3,
    name: 'Блог',
  },
  {
    id: 4,
    name: 'E-Commerce',
  },
  {
    id: 5,
    name: 'Веб-сайт',
  },
  {
    id: 6,
    name: 'Email',
  },
  // {
  //   id: 7,
  //   name: 'Бизнес',
  // },
];
